import { html, type TemplateResult } from 'lit';
import { BRAND_UI } from '../../../brandAssets.ts';
import type { CoreShellPorts } from '../../../../../routing/domain/CoreShellPorts.ts';
import { shellOfflineUpdateBannerTemplate } from '../../../shellOfflineUpdateBannerTemplate.ts';
import './SidebarComponent.ts';
/** Layout component template. */


export function layoutComponentTemplate(p: {
  appTitle: string;
  shellPorts: CoreShellPorts;
  showOfflineUpdateBanner: boolean;
  onGoToOfflineUpdate: () => void;
  onLogout: () => void;
}): TemplateResult {
  const escudoSrc = BRAND_UI.escudoHeaderLogo;
  return html`
    <div
      class="flex h-[100dvh] max-h-[100dvh] min-h-0 flex-col overflow-hidden bg-[color:var(--md-sys-color-surface)] text-[color:var(--md-sys-color-on-surface)]"
    >
      <sidebar-component id="sidebar" .shellPorts=${p.shellPorts}></sidebar-component>

      <div class="flex min-h-0 flex-1 flex-col lg:pl-20">
        <header
          role="banner"
          class="sticky top-0 z-30 flex min-h-16 shrink-0 items-center gap-3 border-b border-[color:var(--md-sys-color-outline-variant)] bg-[color:var(--md-sys-color-surface-container)] px-4 py-3 shadow-[var(--md-elevation-1)]"
          style="padding-top: max(0.75rem, env(safe-area-inset-top));"
        >
          <div class="flex min-w-0 flex-1 items-center gap-3">
            <img
              class="h-10 w-auto shrink-0 object-contain"
              src="${escudoSrc}"
              width="40"
              height="40"
              alt=""
              decoding="async"
            />
            <h1
              class="min-w-0 truncate text-[length:1.375rem] font-normal leading-snug tracking-tight text-[color:var(--md-sys-color-on-surface)]"
            >
              ${p.appTitle}
            </h1>
          </div>
          <button
            type="button"
            class="md-sys-ripple touch-manipulation flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-[color:var(--md-sys-color-on-surface-variant)] outline-none hover:bg-black/[0.06] focus-visible:ring-2 focus-visible:ring-[color:var(--md-sys-color-primary)]"
            aria-label="Cerrar sesión"
            @click=${p.onLogout}
          >
            <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
              />
            </svg>
          </button>
        </header>

        ${p.showOfflineUpdateBanner ? shellOfflineUpdateBannerTemplate(p.onGoToOfflineUpdate) : null}

        <main
          class="layout-main-scroll min-h-0 flex-1 overflow-auto pb-[calc(5rem+env(safe-area-inset-bottom,0px))] lg:pb-0"
        >
          <div id="main" class="px-4 py-3 lg:px-6 lg:py-4"></div>
        </main>
      </div>
    </div>
  `;
}
